// created by wangshuyi on 2022/9/1

'use strict';
import router from '@/router';

const state = {
  cookieName: process.env.VUE_APP_COOKIE_NAME,
  loading: false,

  menuActive: {},
  menuTab: [],

  prompt: {
    title: '请输入',
    desc: null,
    icon: null,
    visible: false,
    type: 'input',
    onOk: null,
    onCancel: null,
    value: null,
  }
};

const mutations = {
  init(state) {
    const sessionStorageStr = sessionStorage.getItem(state.cookieName);
    if (sessionStorageStr) {
      const sessionInfo = JSON.parse(sessionStorageStr);
      for (const module in sessionInfo) {
        if(/lang/.test(module)){
          continue
        }
        for (const field in sessionInfo[module]) {
          if (/loading|prompt/.test(field)) {
            continue;
          }

          this.state[module][field] = sessionInfo[module][field];
        }
      }
    }
  },
  session(state) {
    sessionStorage.setItem(state.cookieName, JSON.stringify(this.state));
  },
  setLoading(state, flag) {
    state.loading = flag;
  },

  initRouteConfig(){
    function getFirstMenu(menu){
      if(menu.children && menu.children.length > 0){
        return getFirstMenu(menu.children[0]);
      }else{
        return menu;
      }
    }
    const firstMenu = getFirstMenu(this.state.user.menuList[0]);
  },
};

const actions = {
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
